{
  "common": {
    "appName": "Partake",
    "appDownloadPrompt": {
      "guest": "¿Te gusta lo que ves? Lleva Partake en tu teléfono y recibe nuevas disponibilidades cerca de ti",
      "qrCodeAccessibilityLabel": "Código QR para descargar la aplicación Partake"
    },
    "postalCodeRequiredError": "Por favor ingresa un zip code"
  },
  "contact-information": {
    "title": "Tu Zip Code",
    "prompt": "¡Agrega tu zip code para descubrir todo lo que puedes tomar prestado cerca de ti!",
    "invalidAddressError": "Zip code inválido. Por favor inténtalo de nuevo.",
    "changePostalCode": "Cambiar mi zip code"
  },
  "contact-us": {
    "firstParagraph": "El servicio a los miembros de Partake está disponible por correo electrónico y mensajería. Te responderemos a la brevedad posible.",
    "faqLink": "https://www.we-partake.com/fr-us/about/frequently-asked-questions"
  },
  "free-sub": {
    "headerTextNotYet": "¡Contribuyes a hacer crecer el catálogo de <strong>Partake</strong>!"
  },
  "guidelines": {
    "fifthParagraph": "No utilizar Partake para vender objetos."
  },
  "help": {
    "compensation": {
      "subscribeText": "Con la suscripción, Partake te compensa hasta 300 $ en los objetos que prestas y tomas prestados."
    }
  },
  "impact": {
    "levels": {
      "0": {
        "description-completed": "Se unió a Partake"
      }
    }
  },
  "introModal": {
    "pageTitle": {
      "newly_insured": "La Responsabilidad Partake"
    },
    "titleNewFeature": "¡Partake es responsable!",
    "welcome": {
      "regular": "<strong>¡Bienvenido al Club!</strong>\nComo miembro oficial de Partake, tu suscripción te da acceso a nuevas ventajas."
    },
    "custom": {
      "support": "<strong>¿Un daño? ¿Un problema? Partake te garantiza atención a los miembros en todo momento.</strong>"
    }
  },
  "landing-page": {
    "immature": {
      "writeToMayor": {
        "title": "Pide a tu ciudad que ofrezca Partake a sus ciudadanos"
      }
    }
  },
  "insured": {
    "landing-page": {
      "title": "Responsabilidad Partake"
    },
    "listing": {
      "text": {
        "own": "Con tu suscripción, disfrutas de la Responsabilidad Partake en caso de daño a tus objetos.",
        "other": "Con su suscripción, {{name}} disfruta de la Responsabilidad Partake en caso de daño a sus objetos."
      }
    },
    "myPlan": {
      "title": "Partake es responsable",
      "text": "Al suscribirte, disfrutas de la Responsabilidad Partake si un objeto que prestas o tomas prestado resulta dañado."
    },
    "profile": {
      "title": "{{name}} disfruta de la Responsabilidad Partake en caso de daño a sus objetos."
    },
    "details": {
      "title": "Responsabilidad Partake"
    }
  },
  "invite": {
    "referralProgram": {
      "title": "¿Te gusta Partake?\n<color>Por cada referencia</color> te ofrecemos <color>¡1 mes gratis!</color>",
      "details": "Cada vez que un amigo se suscribe con tu enlace de referencia, recibes 1 mes gratis en Partake.",
      "referrals": {
        "subTitle_one": "<strong>{{count}} persona</strong> se unió a Partake gracias a <strong>ti</strong> 🥳",
        "subTitle": "<strong>{{count}} personas</strong> se unieron a Partake gracias a <strong>ti</strong> 🥳"
      },
      "gift": {
        "prefix": "Por cada persona referida, recibes automáticamente un mes gratis en Partake."
      },
      "shareText": "¡Hola!\n\nUso Partake, una app genial para prestar y tomar prestados objetos cotidianos entre vecinos: herramientas, juegos, material deportivo… ¡todo lo que quieras!\nEstoy seguro/a de que te va a encantar. Únete aquí:\n\n{{url}}"
    },
    "referralProgram202506": {
      "title": "¿Te gusta Partake?\n<color>Invita a 5 personas</color> y te damos <color>¡un regalo de 25 $!</color>",
      "shareText": "¡Hola!\n\nUso Partake, una app genial para prestar y tomar prestados objetos entre vecinos: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy segura de que te va a interesar. Únete aquí:\n\n{{url}}"
    },
    "shareText": "¡Hola!\n\nUso Partake, una app genial para prestar y tomar prestados objetos entre vecinos: herramientas, juegos, artículos deportivos… ¡de todo!\nEstoy segura de que te va a interesar. Únete aquí:\n\n{{url}}",
    "referrals": {
      "subTitle_one": "<strong>{{count}} persona</strong> se unió a Partake gracias a <strong>ti</strong> 🥳",
      "subTitle": "<strong>{{count}} personas</strong> se unieron a Partake gracias a <strong>ti</strong> 🥳"
    }
  },
  "my-address": {
    "postalCodeFieldLabel": "Zip Code"
  },
  "my-neighbourhood": {
    "postalCodeLabel": "Zip Code"
  },
  "my-plan": {
    "businessPlan": {
      "title": {
        "municipal": "Suscripción Partake+",
        "municipal_closed": "Suscripción Partake+"
      }
    },
    "design": {
      "shareReferral": "Únete a mí en Partake: {{url}}"
    },
    "freeSubText": {
      "trial": "¡Contribuye a hacer crecer el catálogo de <strong>Partake</strong>! ¡Publica 5 objetos y gana tu <strong>suscripción anual</strong>!"
    },
    "referralProgram": {
      "subtitle": "Por cada persona referida, obtienes automáticamente un mes gratis en Partake."
    }
  },
  "notifications": {
    "impactLevelExplorerMessage": "Comienza tu experiencia en Partake. Publica un objeto para hacer crecer tu impacto y pasar al siguiente nivel.",
    "introModal": {
      "intro": {
        "title": "Bienvenido/a al Club",
        "body": "¡Descubre Partake!"
      },
      "b2c_paid": {
        "body": "Como miembro oficial de Partake, tu suscripción te da acceso a nuevas ventajas."
      },
      "newly_insured": {
        "title": "¡Partake es responsable!"
      }
    },
    "newReferralSubscribed": {
      "receivedPrizeMessage": "¡Bravo! 🥳 ¡Acabas de ganar una suscripción anual gratuita en Partake!",
      "receivedMonthPrizeMessage": "¡Bravo! 🥳 ¡Acabas de ganar un mes gratis en Partake!"
    },
    "welcome": "¡Bienvenido/a a Partake!",
    "rate": {
      "borrower": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partake."
      },
      "lender": {
        "message": "Tu opinión es importante para nosotros y para los otros miembros de Partake."
      }
    }
  },
  "one-channel": {
    "firstLoanPrompt": {
      "description": "Este primer préstamo te lo ofrece completamente Partake"
    },
    "notifNowInsured": "<strong>¡No te preocupes y comparte!\n\nPartake puede indemnizarte hasta 300 $</strong> en caso de problema con artículos prestados de un valor de 25 $ o más.\n\nSi ocurre cualquier cosa, puedes contactarnos aquí, o bien por correo electrónico a <strong>info@we-partake.com</strong>",
    "levelModal": {
      "superSharer": {
        "message": "¡Aumentaste tu impacto realizando 5 intercambios! Ahora accedes al nivel máximo: <strong>Super Compartidor</strong>, un ejemplo a seguir en Partake.\n\n¡Bravo! Con cada intercambio, haces crecer tu impacto para un futuro más verde."
      }
    }
  },
  "one-listing": {
    "needFoundModal": {
      "step2": {
        "gotoSelectLender": "La necesidad fue cubierta en Partake"
      }
    }
  },
  "payment": {
    "mobileRedirect": {
      "subtitle": "La suscripción de Partake está disponible por el momento únicamente en la app móvil.\nUna vez suscrito/a, podrás seguir usando el sitio web para prestar y tomar prestados objetos."
    }
  },
  "paywall": {
    "redesign": {
      "coverageFootnote": "*La Responsabilidad de Partake cubre hasta 300 $ por los objetos prestados o tomados prestados."
    },
    "thirdFeature": "Partake es responsable de los daños causados a los objetos"
  },
  "paywall2": {
    "offer": {
      "trial": "¡Obtén un 25 % de descuento en la suscripción anual y aprovecha plenamente la Responsabilidad Partake!"
    }
  },
  "presentPartageClub": {
    "headerTitle": "Bienvenido a Partake",
    "title": "Bienvenido a Partake",
    "community": {
      "headerText": "Partake es la aplicación de <strong>intercambio de objetos</strong> entre vecinos."
    },
    "accessMore": {
      "headerText": "En Partake, accedes a una <strong>abundancia de objetos</strong>."
    },
    "offerMore": {
      "headerText": "En Partake, tu <strong>generosidad</strong> marca una verdadera <strong>diferencia</strong>."
    }
  },
  "presentCommunity": {
    "headerTitle": "Bienvenido a la comunidad",
    "title": "Bienvenido a la comunidad",
    "newFlow": {
      "coverageFootnote": "*La Responsabilidad de Partake cubre hasta 300 $ por los objetos prestados o tomados prestados."
    },
    "responsibility": {
      "headerText": "¡Partake es <strong>responsable</strong>!"
    },
    "transaction": {
      "headerText": "En Partake, <strong>no hay ningún intercambio de dinero</strong>"
    },
    "trust": {
      "headerText": "En Partake, la <strong>confianza</strong> es lo <strong>primero</strong>"
    },
    "free": {
      "headerText": "En Partake, <strong>prestar</strong> es 100 % gratuito"
    }
  },
  "privacy": {
    "link1": "https://www.we-partake.com/fr-us/terms-and-conditions",
    "link2": "https://www.we-partake.com/fr-us/privacy-policy",
    "button3Text": "Responsabilidad de Partake",
    "link3": "https://www.we-partake.com/fr-us/terms-and-conditions#responsabilite"
  },
  "quick-new-thanks": {
    "bodyText": "¡Acabas de contribuir a enriquecer el catálogo de <strong>Partake</strong>!"
  },
  "ratings": {
    "notGreat": {
      "ctaButton": "Contactar a Partake"
    },
    "newRating": {
      "commentHelp": "Visible solo para el equipo de Partake. Úsalo para reportar problemas o aportar contexto."
    }
  },
  "neighbour-profile": {
    "reviews": {
      "sheet": {
        "paragraph1": "En Partake, las evaluaciones ayudan a construir una comunidad de confianza para compartir de forma más segura."
      }
    }
  },
  "trialPromo": {
    "title": "¡Contribuye a hacer crecer el catálogo de Partake y gana tu suscripción!",
    "details": "¡Contribuye a hacer crecer el catálogo de <strong>Partake</strong>! ¡Publica 5 objetos y gana tu <strong>suscripción anual</strong>! 🥳"
  },
  "tutorial": {
    "publishOffers": {
      "step1": {
        "text": "Aquí reina la <strong>confianza</strong>. Todos los miembros se comprometen a respetar las reglas de oro.\n\nEn caso de problema, <strong>el equipo de Partake</strong> está a tu servicio en todo momento. (1/5)"
      }
    }
  },
  "ambassador": {
    "description": {
      "isAmbassador": "Un·a embajador·a es un miembro comprometido que <strong>contribuye activamente a hacer vivir el intercambio en su comunidad</strong>. Actúa como <strong>referente local</strong>, facilita los intercambios y ayuda a Partake a crecer de forma humana y auténtica.",
      "notYetAmbassador": "Un·a embajador·a es un miembro comprometido que <strong>contribuye activamente a hacer vivir el intercambio en su comunidad</strong>. Actúa como <strong>referente local</strong>, facilita los intercambios y ayuda a Partake a crecer de forma humana y auténtica."
    },
    "advantages": {
      "advantage3": {
        "body": "Da tu opinión sobre las futuras prioridades y proyectos de Partake y del programa embajador"
      },
      "advantage4": {
        "title": "Invitaciones especiales a eventos de Partake"
      },
      "advantage5": {
        "title": "Acceso a objetos proporcionados por Partake"
      }
    },
    "mission": {
      "concrete1": "Dar a conocer Partake en tu entorno"
    }
  },
  "support-profile": {
    "managePlan": "Gestionar mi suscripción a Partake"
  }
}
